import { RovoChatBoxContainer } from "@/templates/software/rovo/start/software-rovo-start-page/src/chat";

const UniformRovoChatBox = () => {
    return <RovoChatBoxContainer />;
};

export default UniformRovoChatBox;
